// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tryitouteditor ngx-monaco-editor {
  width: 100%;
  height: 58vh;
  position: relative;
  right: 16px;
}

::ng-deep.myCustomModalClassfromxml.modal.show {
  z-index: 1050 !important;
  height: 94vh;
  width: 102vw;
  left: -1.3%;
  top: 3%;
}

::ng-deep.myCustomModalClassfromxml .modal-dialog {
  max-width: 97%;
  max-height: 60%;
  height: 60%;
  margin: auto;
  padding: 0 !important;
}
::ng-deep.myCustomModalClassfromxml .modal-dialog .modal-content {
  height: 88vh !important;
  background-color: #fff !important;
}
::ng-deep.myCustomModalClassfromxml .modal-dialog .modal-content .tryitouteditorin {
  height: 60vh !important;
}
::ng-deep.myCustomModalClassfromxml .modal-dialog .modal-content .tryitouteditorout {
  height: 66vh !important;
}

.tryitout-input-editor-container,
.tryitout-output-editor-container {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: visible;
  position: relative;
}

::ng-deep .tryitout-input-editor-container .editor-container,
::ng-deep .tryitout-output-editor-container .editor-container {
  width: 100% !important;
  max-width: 100% !important;
  overflow-x: hidden !important;
  overflow-y: visible !important;
}
::ng-deep .tryitout-input-editor-container .editor-container .monaco-editor,
::ng-deep .tryitout-output-editor-container .editor-container .monaco-editor {
  width: 100% !important;
  max-width: 100% !important;
}
::ng-deep .tryitout-input-editor-container .editor-container .monaco-editor .overflow-guard,
::ng-deep .tryitout-output-editor-container .editor-container .monaco-editor .overflow-guard {
  width: 100% !important;
  max-width: 100% !important;
  overflow: visible !important;
}
::ng-deep .tryitout-input-editor-container .editor-container .monaco-editor .overflow-guard .monaco-scrollable-element.editor-scrollable,
::ng-deep .tryitout-output-editor-container .editor-container .monaco-editor .overflow-guard .monaco-scrollable-element.editor-scrollable {
  max-width: 100% !important;
}
::ng-deep .tryitout-input-editor-container .editor-container .monaco-editor .minimap,
::ng-deep .tryitout-output-editor-container .editor-container .monaco-editor .minimap {
  width: 70px !important;
  min-width: 70px !important;
  max-width: 70px !important;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}
::ng-deep .tryitout-input-editor-container .editor-container .monaco-editor .minimap-slider,
::ng-deep .tryitout-output-editor-container .editor-container .monaco-editor .minimap-slider {
  display: block !important;
  visibility: visible !important;
}
::ng-deep .tryitout-input-editor-container .editor-container .monaco-editor .minimap canvas,
::ng-deep .tryitout-output-editor-container .editor-container .monaco-editor .minimap canvas {
  display: block !important;
  visibility: visible !important;
}

.example-tree-invisible {
  display: none;
}

.example-tree ul,
.example-tree li {
  margin-top: 0;
  margin-bottom: 0;
  list-style-type: none;
}

.textColor {
  color: green;
}

.mat-tree-node {
  min-height: 1px;
  align-items: flex-start;
}

.mat-icon-button {
  height: 1px;
  width: 20px;
}

.mat-icon-rtl-mirror {
  vertical-align: top;
}

.accession_field {
  height: 28px !important;
  margin-left: 3%;
  padding-left: 2%;
  font-size: 12px !important;
}

.accession_field::placeholder {
  font-size: 12px !important;
}

.field_droping {
  width: 100%;
  margin-left: 4%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  top: -3px;
  background-color: rgb(255, 255, 255);
  left: -5px;
  height: 32px;
}

::ng-deep .field_droping .mat-form-field-wrapper {
  padding-bottom: 0 !important;
}

::ng-deep .field_droping .mat-form-field-flex {
  padding: 0 !important;
}

.mod_header {
  padding-inline: 1%;
  background-color: #17a0b4 !important;
  padding-block: 5px;
  font-size: 12px !important;
  color: white;
}

.tryitout-header-wrap {
  width: 100%;
}

.tryitout-header-bar {
  gap: 12px;
  row-gap: 8px;
}

.tryitout-field-label {
  color: #fff;
  font-weight: 800;
  white-space: nowrap;
  font-size: 12px !important;
}

.tryitout-mode-radios {
  gap: 0;
  margin-right: 4px;
}
.tryitout-mode-radios ::ng-deep .mat-mdc-radio-button {
  --mdc-radio-unselected-icon-color: #fff;
  --mdc-radio-selected-icon-color: #fff;
  --mdc-radio-unselected-hover-icon-color: #fff;
  --mdc-radio-selected-hover-icon-color: #fff;
  --mdc-radio-unselected-pressed-icon-color: #fff;
  --mdc-radio-selected-pressed-icon-color: #fff;
  --mat-radio-checked-ripple-color: rgba(255, 255, 255, 0.25);
  --mat-radio-ripple-color: rgba(255, 255, 255, 0.25);
  --mat-radio-label-text-color: #fff;
  --mat-radio-disabled-label-color: rgba(255, 255, 255, 0.5);
}
.tryitout-mode-radios ::ng-deep .mat-mdc-radio-button .mdc-label {
  color: #fff !important;
  font-weight: 600;
  font-size: 12px;
  margin-bottom: 0;
}
.tryitout-mode-radios ::ng-deep .mat-mdc-radio-button .mdc-radio__outer-circle {
  border-color: #fff !important;
}
.tryitout-mode-radios ::ng-deep .mat-mdc-radio-button .mdc-radio__native-control:enabled:not(:checked) + .mdc-radio__background .mdc-radio__outer-circle {
  border-color: rgba(255, 255, 255, 0.9) !important;
}
.tryitout-mode-radios ::ng-deep .mat-mdc-radio-button .mdc-radio__native-control:enabled:checked + .mdc-radio__background .mdc-radio__outer-circle {
  border-color: #fff !important;
}
.tryitout-mode-radios ::ng-deep .mat-mdc-radio-button .mdc-radio__native-control:enabled:checked + .mdc-radio__background .mdc-radio__inner-circle {
  border-color: #fff !important;
}
.tryitout-mode-radios ::ng-deep .mat-radio-label-content {
  color: #fff !important;
  font-weight: 600;
}
.tryitout-mode-radios ::ng-deep .mat-radio-outer-circle {
  border-color: rgba(255, 255, 255, 0.9) !important;
}
.tryitout-mode-radios ::ng-deep .mat-radio-inner-circle {
  background-color: #fff !important;
}
.tryitout-mode-radios ::ng-deep .mat-radio-checked .mat-radio-outer-circle {
  border-color: #fff !important;
}
.tryitout-mode-radios ::ng-deep .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-persistent-ripple,
.tryitout-mode-radios ::ng-deep .mat-radio-button.mat-accent .mat-radio-ripple .mat-ripple-element {
  background-color: rgba(255, 255, 255, 0.25) !important;
}

.tryitout-field {
  min-width: 0;
}

.tryitout-field-pipeline {
  flex: 1 1 280px;
  max-width: 520px;
}

.tryitout-export-panel {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 24px;
  padding-bottom: 24px;
  min-height: 200px;
  background: #f4f6f9;
}

.tryitout-export-card {
  width: 100%;
  max-width: 980px;
  border: 1px solid #dfe5ec;
  border-radius: 12px;
  background-color: #fff;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);
}

.tryitout-export-card-header {
  padding: 10px 20px;
  border-bottom: 1px solid #e8edf3;
  gap: 14px;
}

.tryitout-export-card-header-icon {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  background: #17a0b4;
  color: #fff;
  font-size: 15px;
}

.tryitout-export-card-title {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.2;
}

.tryitout-export-card-subtitle {
  margin-top: 2px;
  color: #7b8794;
  font-size: 13px;
}

.tryitout-export-card-subtitle--mandatory {
  color: #dc3545;
  font-weight: 500;
}

.tryitout-export-card-body {
  padding: 16px 20px 18px;
  gap: 14px;
}

.tryitout-export-form {
  width: 100%;
}

.tryitout-export-fields-panel {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 24px;
  border: 1px solid #e8edf3;
  border-radius: 8px;
  padding: 14px;
  background: #fafbfd;
}

.tryitout-export-form-row {
  min-height: 64px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.tryitout-export-field-head {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tryitout-export-field-icon {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #17a0b4;
  background: #e7f3f8;
}
.tryitout-export-field-icon mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #17a0b4;
}

.tryitout-export-label {
  font-weight: 600;
  color: #334155;
  font-size: 13px;
}

.tryitout-export-control {
  width: 100%;
}

.tryitout-export-card-actions {
  gap: 10px;
  margin-top: 2px;
  padding-top: 14px;
  border-top: 1px solid #e8edf3;
}

.tryitout-field-control {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
}

.tryitout-processor {
  color: #fff;
  max-width: 360px;
}

.tryitout-copy-icon {
  cursor: pointer;
}

::ng-deep .tryitout-header-bar .autocomplete-container {
  height: 32px;
}

::ng-deep .tryitout-header-bar .autocomplete-container .input-container input {
  height: 32px !important;
}

::ng-deep .tryitout-export-card .autocomplete-container {
  position: relative;
  box-shadow: none !important;
  height: 34px;
  border-radius: 5px;
  overflow: visible !important;
}
::ng-deep .tryitout-export-card .autocomplete-container.active {
  z-index: 1000;
}
::ng-deep .tryitout-export-card .autocomplete-container .input-container input {
  height: 34px !important;
  border-radius: 5px !important;
  border: 1px solid #d3dce7 !important;
  background-color: #fff !important;
  font-size: 12px !important;
  padding-right: 12% !important;
}
::ng-deep .tryitout-export-card .autocomplete-container .input-container input:disabled {
  background-color: #f5f7fa !important;
  cursor: not-allowed;
  color: rgba(0, 0, 0, 0.6);
}
::ng-deep .tryitout-export-card .autocomplete-container .suggestions-container {
  position: absolute !important;
  top: calc(100% + 2px) !important;
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
  overflow: hidden !important;
  z-index: 1001 !important;
  background: #fff !important;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important;
  box-sizing: border-box;
}
::ng-deep .tryitout-export-card .autocomplete-container .suggestions-container.is-visible {
  z-index: 1001 !important;
}
::ng-deep .tryitout-export-card .autocomplete-container .suggestions-container ul {
  margin: 0;
}
::ng-deep .tryitout-export-card .autocomplete-container .suggestions-container ul li a {
  padding: 8px 12px !important;
  font-size: 12px !important !important;
  white-space: normal;
  word-break: break-word;
}
::ng-deep .tryitout-export-card .tryitout-export-control-vendor .autocomplete-container .suggestions-container {
  max-height: 200px !important;
}
::ng-deep .tryitout-export-card .tryitout-export-control-vendor .autocomplete-container .suggestions-container ul {
  max-height: 100px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}
::ng-deep .tryitout-export-card .tryitout-export-control-msgtype .autocomplete-container .suggestions-container {
  max-height: 170px !important;
}
::ng-deep .tryitout-export-card .tryitout-export-control-msgtype .autocomplete-container .suggestions-container ul {
  max-height: 100px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}
::ng-deep .tryitout-export-card .tryitout-export-control-conversion .autocomplete-container .suggestions-container {
  max-height: 80px !important;
}
::ng-deep .tryitout-export-card .tryitout-export-control-conversion .autocomplete-container .suggestions-container ul {
  max-height: 100px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}
::ng-deep .tryitout-export-card .export-accession-input,
::ng-deep .tryitout-export-card .export-direction-select {
  width: 100%;
  height: 34px !important;
  border-radius: 5px;
  border: 1px solid #d3dce7;
  box-shadow: none !important;
  background-color: #fff;
  font-size: 12px;
  padding: 6px 12px;
  color: rgba(0, 0, 0, 0.87);
}
::ng-deep .tryitout-export-card .export-accession-input:focus,
::ng-deep .tryitout-export-card .export-direction-select:focus {
  border-color: #9e9e9e;
  outline: none;
  box-shadow: none !important;
}
::ng-deep .tryitout-export-card .export-direction-select--readonly {
  cursor: default;
  background-color: #f5f7fa;
}
::ng-deep .tryitout-export-card .export-direction-select--editable {
  cursor: pointer;
  padding-top: 0;
  padding-bottom: 0;
}
::ng-deep .tryitout-export-card .export-direction-select--editable ::ng-deep .mat-mdc-select-trigger,
::ng-deep .tryitout-export-card .export-direction-select--editable ::ng-deep .mat-select-trigger {
  height: 34px;
  align-items: center;
}

::ng-deep .cdk-overlay-pane:has(.tryitout-export-direction-panel) {
  transform: translateX(-10px);
}

::ng-deep .cdk-overlay-container .mat-mdc-select-panel.tryitout-export-direction-panel {
  --mat-minimal-pseudo-checkbox-selected-checkmark-color: #157a9f;
  --mat-full-pseudo-checkbox-selected-icon-color: #157a9f;
}
::ng-deep .cdk-overlay-container .mat-mdc-select-panel.tryitout-export-direction-panel .mat-mdc-option.mdc-list-item--selected .mat-pseudo-checkbox-minimal.mat-pseudo-checkbox-checked::after,
::ng-deep .cdk-overlay-container .mat-mdc-select-panel.tryitout-export-direction-panel .mat-mdc-option.mdc-list-item--selected .mat-pseudo-checkbox-full.mat-pseudo-checkbox-checked::after {
  color: #157a9f !important;
}

@media (max-width: 767px) {
  .tryitout-export-fields-panel {
    grid-template-columns: 1fr;
  }
}
.Template_dropDown {
  height: 32px;
  border-radius: 5px;
  padding-inline: 1%;
  position: relative;
  top: 1%;
  background-color: white;
  margin-left: 1px;
  margin-right: 2%;
  margin-block: 1%;
}

::ng-deep.Template_dropDown .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.Template_dropDown .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.Template_dropDown .mat-form-field-label-wrapper {
  top: -1px !important;
}

::ng-deep.Template_dropDown .mat-select-trigger {
  min-width: 10vw;
}

.mat_selection {
  margin-left: 4%;
  margin-bottom: 4%;
  height: 35px;
  border-radius: 5px;
  padding-inline: 1%;
  padding-bottom: 1%;
}

::ng-deep.mat_selection .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.mat_selection .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.mat-selection_label .mat-form-field-label-wrapper {
  position: absolute !important;
  top: 1px !important;
}

::ng-deep.mat-selection_label .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.selection_label .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.selection_label .mat-select-trigger {
  min-width: 10vw;
}

::ng-deep.path_class {
  width: 100%;
}

::ng-deep.pushmodal .modal-dialog {
  max-width: 50% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.pushmodal {
  top: 4% !important;
}

.ellipsisfull {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* width: 100% !important; */
  max-width: 90%;
}

::ng-deep .field_droping .mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {
  margin-left: 8px !important;
}

::ng-deep .field_droping .mat-form-field-appearance-outline .mat-form-field-infix {
  padding: 3px 7px !important;
}

::ng-deep.Version_dropDowns .mat-form-field-wrapper .mat-form-field-flex .mat-form-field-infix .mat-select .mat-select-trigger .mat-select-value {
  width: 65% !important;
}

.Version_dropDowns {
  height: 32px;
  border-radius: 5px;
  position: relative;
  top: -7px;
  background-color: white;
  margin-block: 1%;
  padding-left: 5px;
  width: 60%;
}

::ng-deep.Version_dropDowns .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.Version_dropDowns .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.Version_dropDowns .mat-form-field-label-wrapper {
  top: -1px !important;
}

::ng-deep.Version_dropDowns .mat-select-trigger {
  min-width: 13vw !important;
}

::ng-deep.Version_dropDowns .mat-select-arrow {
  position: relative !important;
  right: 47% !important;
}

::ng-deep.myCustomModalViewfilehl7Viewer .modal-dialog {
  max-width: 80% !important;
  max-height: 60% !important;
  height: 60% !important;
  padding: 0 !important;
  display: flex !important;
  justify-content: center !important;
}
::ng-deep.myCustomModalViewfilehl7Viewer .modal-dialog .modal-content {
  height: 70vh;
}

::ng-deep.myCustomModalViewfilehl7ViewerFromCreate .modal-dialog {
  max-width: 80% !important;
  max-height: 60% !important;
  height: 60% !important;
  padding: 0 !important;
  display: flex !important;
  justify-content: center !important;
}
::ng-deep.myCustomModalViewfilehl7ViewerFromCreate .modal-dialog .modal-content {
  height: 70vh;
}

::ng-deep.matoutlinestyles.versionfield {
  width: 70% !important;
}
::ng-deep.matoutlinestyles.versionfield .mat-mdc-text-field-wrapper {
  padding-block: 0px !important;
}

::ng-deep.modal-backdrop.show {
  z-index: 1050 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/tryitout/tryitout.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AADF;;AAIA;EACE,wBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;AADF;;AAGA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AAAF;AAEE;EACE,uBAAA;EACA,iCAAA;AAAJ;AACI;EACE,uBAAA;AACN;AACI;EACE,uBAAA;AACN;;AAIA;;EAEE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AADF;;AAOE;;EACE,sBAAA;EACA,0BAAA;EACA,6BAAA;EACA,8BAAA;AAHJ;AAKI;;EACE,sBAAA;EACA,0BAAA;AAFN;AAIM;;EACE,sBAAA;EACA,0BAAA;EAEA,4BAAA;AAFR;AAIQ;;EAEE,0BAAA;AAFV;AAOM;;EACE,sBAAA;EACA,0BAAA;EACA,0BAAA;EACA,yBAAA;EACA,8BAAA;EACA,qBAAA;AAJR;AAQM;;EACE,yBAAA;EACA,8BAAA;AALR;AASM;;EACE,yBAAA;EACA,8BAAA;AANR;;AAWA;EACE,aAAA;AARF;;AAWA;;EAEE,aAAA;EACA,gBAAA;EACA,qBAAA;AARF;;AAUA;EACE,YAAA;AAPF;;AASA;EACE,eAAA;EACA,uBAAA;AANF;;AAQA;EACE,WAAA;EACA,WAAA;AALF;;AASA;EACE,mBAAA;AANF;;AAsCA;EACE,uBCnJU;EDoJV,eAAA;EACA,gBAAA;EACA,0BCxJS;ADqHX;;AAqCA;EACE,0BC3JS;ADyHX;;AAoCA;EACE,WAAA;EACE,eAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,oCAAA;EACA,UAAA;EACA,YAAA;AAjCJ;;AAmCC;EACC,4BAAA;AAhCF;;AAkCA;EACE,qBAAA;AA/BF;;AAmCA;EACE,kBAAA;EACA,oCCnLU;EDoLV,kBAAA;EACA,0BCpLS;EDqLT,YAAA;AAhCF;;AAmCA;EACE,WAAA;AAhCF;;AAmCA;EACE,SAAA;EACA,YAAA;AAhCF;;AAmCA;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BCrMS;ADqKX;;AAmCA;EACE,MAAA;EACA,iBAAA;AAhCF;AAmCE;EACE,uCAAA;EACA,qCAAA;EACA,6CAAA;EACA,2CAAA;EACA,+CAAA;EACA,6CAAA;EACA,2DAAA;EACA,mDAAA;EACA,kCAAA;EACA,0DAAA;AAjCJ;AAmCI;EACE,sBAAA;EACA,gBAAA;EACA,eAAA;EACF,gBAAA;AAjCJ;AAoCI;EACE,6BAAA;AAlCN;AAqCI;EACE,iDAAA;AAnCN;AAuCM;EACE,6BAAA;AArCR;AAwCM;EACE,6BAAA;AAtCR;AA4CE;EACE,sBAAA;EACA,gBAAA;AA1CJ;AA6CE;EACE,iDAAA;AA3CJ;AA8CE;EACE,iCAAA;AA5CJ;AA+CE;EACE,6BAAA;AA7CJ;AAgDE;;EAEE,sDAAA;AA9CJ;;AAkDA;EACE,YAAA;AA/CF;;AAkDA;EACE,eAAA;EACA,gBAAA;AA/CF;;AAmDA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;AAhDF;;AAmDA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,8CAAA;AAhDF;;AAmDA;EACE,kBAAA;EACA,gCAAA;EACA,SAAA;AAhDF;;AAmDA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AAhDF;;AAmDA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAhDF;;AAmDA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAhDF;;AAmDA;EACE,cAAA;EACA,gBAAA;AAhDF;;AAmDA;EACE,uBAAA;EACA,SAAA;AAhDF;;AAmDA;EACE,WAAA;AAhDF;;AAmDA;EACE,aAAA;EACA,8BAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAhDF;;AAmDA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAhDF;;AAmDA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAhDF;;AAmDA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAhDF;AAkDE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAhDJ;;AAoDA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAjDF;;AAoDA;EACE,WAAA;AAjDF;;AAoDA;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;AAjDF;;AA2DA;EACE,cAAA;EACA,YAAA;EACA,WAAA;AAxDF;;AA2DA;EACE,WAAA;EACA,gBAAA;AAxDF;;AA2DA;EACE,eAAA;AAxDF;;AA2DA;EACE,YAAA;AAxDF;;AA2DA;EACE,uBAAA;AAxDF;;AAwEE;EACE,kBAAA;EACA,2BAAA;EACA,YA7C2B;EA8C3B,kBA7C2B;EA8C3B,4BAAA;AArEJ;AAuEI;EACE,aAAA;AArEN;AAwEI;EACE,uBAAA;EACA,6BAAA;EACA,oCAAA;EACA,iCAAA;EACA,0BAAA;EACA,6BAAA;AAtEN;AAwEM;EACE,oCAAA;EACA,mBAAA;EACA,yBAAA;AAtER;AA0EI;EACE,6BAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,wBAAA;EACA,2BAAA;EACA,kBA5EyB;EA6EzB,mDAAA;EACA,sBAAA;AAxEN;AA2EI;EACE,wBAAA;AAzEN;AA4EI;EACE,SAAA;AA1EN;AA6EI;EACE,4BAAA;EACA,qCAAA;EACA,mBAAA;EACA,sBAAA;AA3EN;AAWE;EACE,4BAAA;AATJ;AAYE;EACE,4BAAA;EACA,2BAAA;EACA,6BAAA;AAVJ;AAGE;EACE,4BAAA;AADJ;AAIE;EACE,4BAAA;EACA,2BAAA;EACA,6BAAA;AAFJ;AALE;EACE,2BAAA;AAOJ;AAJE;EACE,4BAAA;EACA,2BAAA;EACA,6BAAA;AAMJ;AAmEE;;EAEE,WAAA;EACA,uBAAA;EACA,kBAjH2B;EAkH3B,yBAjH2B;EAkH3B,2BAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;AAjEJ;AAmEI;;EACE,qBAAA;EACA,aAAA;EACA,2BAAA;AAhEN;AAoEE;EACE,eAAA;EACA,yBAAA;AAlEJ;AAqEE;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AAnEJ;AAqEI;;EAEE,YA7IyB;EA8IzB,mBAAA;AAnEN;;AAyEA;EACE,4BAAA;AAtEF;;AAyEA;EACE,+DAAA;EACA,uDAAA;AAtEF;AAwEE;;EAEE,yBAAA;AAtEJ;;AA0EA;EACE;IACE,0BAAA;EAvEF;AACF;AA0EA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAxEF;;AA0EA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AAvEF;;AAyEA;EACE,WAAA;EACA,UAAA;AAtEF;;AAwEA;EACE,oBAAA;AArEF;;AAuEA;EACE,eAAA;AApEF;;AAsEA;EAEE,eAAA;EACA,iBAAA;EACA,YAAA;EAEA,kBAAA;EACA,kBAAA;EACA,kBAAA;AArEF;;AAuEA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AApEF;;AAsEA;EACE,WAAA;EACA,UAAA;AAnEF;;AAqEA;EACE,6BAAA;EACA,mBAAA;AAlEF;;AAoEA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AAjEF;;AAmEA;EACE,WAAA;EACA,UAAA;AAhEF;;AAmEA;EACE,eAAA;AAhEF;;AAkEA;EACI,WAAA;AA/DJ;;AAmEA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAhEF;;AAkEA;EACE,kBAAA;AA/DF;;AAkEA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA;EACA,cAAA;AA/DF;;AAkEA;EACE,2BAAA;AA/DF;;AAkEA;EACE,2BAAA;AA/DF;;AAmEA;EACE,qBAAA;AAhEF;;AAkEA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;AA/DF;;AAiEA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AA9DF;;AAgEA;EACE,WAAA;EACA,UAAA;AA7DF;;AA+DA;EACE,oBAAA;AA5DF;;AA8DA;EACE,0BAAA;AA3DF;;AA6DA;EACE,6BAAA;EACA,qBAAA;AA1DF;;AA8DA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,qBAAA;EACA,wBAAA;EAAyB,kCAAA;AA1D3B;AA2DE;EACA,YAAA;AAzDF;;AA4DA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,qBAAA;EACA,wBAAA;EAAyB,kCAAA;AAxD3B;AAyDE;EACA,YAAA;AAvDF;;AA0DA;EAEE,qBAAA;AAxDF;AAyDE;EACE,6BAAA;AAvDJ;;AA0DA;EACA,wBAAA;AAvDA","sourcesContent":["@import \"../../variables.scss\";\r\n\r\n.tryitouteditor ngx-monaco-editor {\r\n  width: 100%;\r\n  height: 58vh;\r\n  position: relative;\r\n  right: 16px;\r\n}\r\n\r\n::ng-deep.myCustomModalClassfromxml.modal.show {\r\n  z-index: 1050 !important;\r\n  height: 94vh;\r\n  width: 102vw;\r\n  left: -1.3%;\r\n  top: 3%;\r\n}\r\n::ng-deep.myCustomModalClassfromxml .modal-dialog {\r\n  max-width: 97%;\r\n  max-height: 60%;\r\n  height: 60%;\r\n  margin: auto;\r\n  padding: 0 !important;\r\n\r\n  .modal-content {\r\n    height: 88vh !important;\r\n    background-color: #fff !important;\r\n    .tryitouteditorin {\r\n      height: 60vh !important;\r\n    }\r\n    .tryitouteditorout {\r\n      height: 66vh !important;\r\n    }\r\n  }\r\n}\r\n// Monaco editor container styles to prevent overflow while allowing minimap\r\n.tryitout-input-editor-container,\r\n.tryitout-output-editor-container {\r\n  width: 100%;\r\n  max-width: 100%;\r\n  overflow-x: hidden;\r\n  overflow-y: visible;\r\n  position: relative;\r\n}\r\n\r\n// Ensure Monaco editors stay within their containers but allow minimap\r\n::ng-deep .tryitout-input-editor-container,\r\n::ng-deep .tryitout-output-editor-container {\r\n  .editor-container {\r\n    width: 100% !important;\r\n    max-width: 100% !important;\r\n    overflow-x: hidden !important;\r\n    overflow-y: visible !important;\r\n    \r\n    .monaco-editor {\r\n      width: 100% !important;\r\n      max-width: 100% !important;\r\n      \r\n      .overflow-guard {\r\n        width: 100% !important;\r\n        max-width: 100% !important;\r\n        // Allow minimap to be visible\r\n        overflow: visible !important;\r\n        \r\n        .monaco-scrollable-element.editor-scrollable {\r\n          // Don't force width to 100% - allow minimap space\r\n          max-width: 100% !important;\r\n        }\r\n      }\r\n      \r\n      // Set minimap width to 70px and ensure it's always visible\r\n      .minimap {\r\n        width: 70px !important;\r\n        min-width: 70px !important;\r\n        max-width: 70px !important;\r\n        display: block !important;\r\n        visibility: visible !important;\r\n        opacity: 1 !important;\r\n      }\r\n      \r\n      // Ensure minimap slider is visible\r\n      .minimap-slider {\r\n        display: block !important;\r\n        visibility: visible !important;\r\n      }\r\n      \r\n      // Ensure minimap canvas is visible\r\n      .minimap canvas {\r\n        display: block !important;\r\n        visibility: visible !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n.example-tree-invisible {\r\n  display: none;\r\n}\r\n\r\n.example-tree ul,\r\n.example-tree li {\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n  list-style-type: none;\r\n}\r\n.textColor{\r\n  color: green;;\r\n}\r\n.mat-tree-node {\r\n  min-height: 1px;\r\n  align-items: flex-start;\r\n}\r\n.mat-icon-button{\r\n  height:1px;\r\n  width: 20px;\r\n}\r\n\r\n\r\n.mat-icon-rtl-mirror{\r\n  vertical-align: top;\r\n}\r\n// ::ng-deep.autocomplete-container {\r\n//   box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n//   position: relative;\r\n//   overflow: visible;\r\n//   height: 40px;\r\n//   border-radius: 5px;\r\n// }\r\n\r\n// ::ng-deep.autocomplete-container .input-container input{\r\n//   border-radius: 5px !important;\r\n//   padding-right: 12% !important;\r\n// }\r\n\r\n// .autocomplete-container {\r\n//   border-radius: 5px !important;\r\n// }\r\n// ::ng-deep.autocomplete-container .input-container .x i{\r\n//   font-weight: 600 !important;\r\n// }\r\n\r\n\r\n\r\n// ::ng-deep.pipeSearch .autocomplete-container {\r\n// height: 35px !important;\r\n// .input-container input{\r\n//   height: 35px !important;\r\n// }\r\n// }\r\n\r\n\r\n.accession_field{\r\n  height: $btnHeight;\r\n  margin-left: 3%;\r\n  padding-left: 2%;\r\n  font-size:$fontsize;\r\n}\r\n.accession_field::placeholder{\r\n  font-size: $fontsize;\r\n}\r\n.field_droping{\r\n  width: 100%;\r\n    margin-left: 4%;\r\n    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n    border-radius: 5px;\r\n    padding-inline: 1%;\r\n    top: -3px;\r\n    background-color: rgb(255, 255, 255);\r\n    left: -5px;\r\n    height: 32px;\r\n}\r\n ::ng-deep .field_droping .mat-form-field-wrapper {\r\n  padding-bottom: 0 !important;\r\n}\r\n::ng-deep .field_droping .mat-form-field-flex {\r\n  padding: 0 !important;\r\n}\r\n\r\n\r\n.mod_header{\r\n  padding-inline: 1%;\r\n  background-color:$btn-color;\r\n  padding-block: 5px;\r\n  font-size: $fontsize;\r\n  color:white;\r\n}\r\n\r\n.tryitout-header-wrap {\r\n  width: 100%;\r\n}\r\n\r\n.tryitout-header-bar {\r\n  gap: 12px;\r\n  row-gap: 8px;\r\n}\r\n\r\n.tryitout-field-label {\r\n  color: #fff;\r\n  font-weight: 800;\r\n  white-space: nowrap;\r\n  font-size: $fontsize;\r\n}\r\n\r\n.tryitout-mode-radios {\r\n  gap: 0;\r\n  margin-right: 4px;\r\n\r\n  // MDC-based mat-radio (Angular Material 15+)\r\n  ::ng-deep .mat-mdc-radio-button {\r\n    --mdc-radio-unselected-icon-color: #fff;\r\n    --mdc-radio-selected-icon-color: #fff;\r\n    --mdc-radio-unselected-hover-icon-color: #fff;\r\n    --mdc-radio-selected-hover-icon-color: #fff;\r\n    --mdc-radio-unselected-pressed-icon-color: #fff;\r\n    --mdc-radio-selected-pressed-icon-color: #fff;\r\n    --mat-radio-checked-ripple-color: rgba(255, 255, 255, 0.25);\r\n    --mat-radio-ripple-color: rgba(255, 255, 255, 0.25);\r\n    --mat-radio-label-text-color: #fff;\r\n    --mat-radio-disabled-label-color: rgba(255, 255, 255, 0.5);\r\n\r\n    .mdc-label {\r\n      color: #fff !important;\r\n      font-weight: 600;\r\n      font-size: 12px;\r\n    margin-bottom: 0;\r\n    }\r\n\r\n    .mdc-radio__outer-circle {\r\n      border-color: #fff !important;\r\n    }\r\n\r\n    .mdc-radio__native-control:enabled:not(:checked) + .mdc-radio__background .mdc-radio__outer-circle {\r\n      border-color: rgba(255, 255, 255, 0.9) !important;\r\n    }\r\n\r\n    .mdc-radio__native-control:enabled:checked + .mdc-radio__background {\r\n      .mdc-radio__outer-circle {\r\n        border-color: #fff !important;\r\n      }\r\n\r\n      .mdc-radio__inner-circle {\r\n        border-color: #fff !important;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Legacy mat-radio (pre-MDC)\r\n  ::ng-deep .mat-radio-label-content {\r\n    color: #fff !important;\r\n    font-weight: 600;\r\n  }\r\n\r\n  ::ng-deep .mat-radio-outer-circle {\r\n    border-color: rgba(255, 255, 255, 0.9) !important;\r\n  }\r\n\r\n  ::ng-deep .mat-radio-inner-circle {\r\n    background-color: #fff !important;\r\n  }\r\n\r\n  ::ng-deep .mat-radio-checked .mat-radio-outer-circle {\r\n    border-color: #fff !important;\r\n  }\r\n\r\n  ::ng-deep .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-persistent-ripple,\r\n  ::ng-deep .mat-radio-button.mat-accent .mat-radio-ripple .mat-ripple-element {\r\n    background-color: rgba(255, 255, 255, 0.25) !important;\r\n  }\r\n}\r\n\r\n.tryitout-field {\r\n  min-width: 0;\r\n}\r\n\r\n.tryitout-field-pipeline {\r\n  flex: 1 1 280px;\r\n  max-width: 520px;\r\n}\r\n\r\n// Export mode: card in main content area\r\n.tryitout-export-panel {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n  padding-top: 24px;\r\n  padding-bottom: 24px;\r\n  min-height: 200px;\r\n  background: #f4f6f9;\r\n}\r\n\r\n.tryitout-export-card {\r\n  width: 100%;\r\n  max-width: 980px;\r\n  border: 1px solid #dfe5ec;\r\n  border-radius: 12px;\r\n  background-color: #fff;\r\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);\r\n}\r\n\r\n.tryitout-export-card-header {\r\n  padding: 10px 20px;\r\n  border-bottom: 1px solid #e8edf3;\r\n  gap: 14px;\r\n}\r\n\r\n.tryitout-export-card-header-icon {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 999px;\r\n  background: #17a0b4;\r\n  color: #fff;\r\n  font-size: 15px;\r\n}\r\n\r\n.tryitout-export-card-title {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #1f2937;\r\n  line-height: 1.2;\r\n}\r\n\r\n.tryitout-export-card-subtitle {\r\n  margin-top: 2px;\r\n  color: #7b8794;\r\n  font-size: 13px;\r\n}\r\n\r\n.tryitout-export-card-subtitle--mandatory {\r\n  color: #dc3545;\r\n  font-weight: 500;\r\n}\r\n\r\n.tryitout-export-card-body {\r\n  padding: 16px 20px 18px;\r\n  gap: 14px;\r\n}\r\n\r\n.tryitout-export-form {\r\n  width: 100%;\r\n}\r\n\r\n.tryitout-export-fields-panel {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 14px 24px;\r\n  border: 1px solid #e8edf3;\r\n  border-radius: 8px;\r\n  padding: 14px;\r\n  background: #fafbfd;\r\n}\r\n\r\n.tryitout-export-form-row {\r\n  min-height: 64px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.tryitout-export-field-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.tryitout-export-field-icon {\r\n  width: 24px;\r\n  height: 24px;\r\n  border-radius: 6px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 12px;\r\n  color: #17a0b4;\r\n  background: #e7f3f8;\r\n\r\n  mat-icon {\r\n    font-size: 16px;\r\n    width: 16px;\r\n    height: 16px;\r\n    color: #17a0b4;\r\n  }\r\n}\r\n\r\n.tryitout-export-label {\r\n  font-weight: 600;\r\n  color: #334155;\r\n  font-size: 13px;\r\n}\r\n\r\n.tryitout-export-control {\r\n  width: 100%;\r\n}\r\n\r\n.tryitout-export-card-actions {\r\n  gap: 10px;\r\n  margin-top: 2px;\r\n  padding-top: 14px;\r\n  border-top: 1px solid #e8edf3;\r\n}\r\n\r\n// Shared export field look (vendor/message type autocomplete, direction, accession)\r\n$tryitout-export-field-height: 34px;\r\n$tryitout-export-field-radius: 5px;\r\n$tryitout-export-field-border: 1px solid #d3dce7;\r\n$tryitout-export-field-shadow: none;\r\n$tryitout-export-input-shadow: none;\r\n\r\n.tryitout-field-control {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n  width: 100%;\r\n}\r\n\r\n.tryitout-processor {\r\n  color: #fff;\r\n  max-width: 360px;\r\n}\r\n\r\n.tryitout-copy-icon {\r\n  cursor: pointer;\r\n}\r\n\r\n::ng-deep .tryitout-header-bar .autocomplete-container {\r\n  height: 32px;\r\n}\r\n\r\n::ng-deep .tryitout-header-bar .autocomplete-container .input-container input {\r\n  height: 32px !important;\r\n}\r\n\r\n@mixin tryitout-export-suggestions-max-height($maxHeight) {\r\n  .autocomplete-container .suggestions-container {\r\n    max-height: $maxHeight !important;\r\n  }\r\n\r\n  .autocomplete-container .suggestions-container ul {\r\n    max-height: 100px !important;\r\n    overflow-y: auto !important;\r\n    overflow-x: hidden !important;\r\n  }\r\n}\r\n\r\n::ng-deep .tryitout-export-card {\r\n  .autocomplete-container {\r\n    position: relative;\r\n    box-shadow: $tryitout-export-field-shadow !important;\r\n    height: $tryitout-export-field-height;\r\n    border-radius: $tryitout-export-field-radius;\r\n    overflow: visible !important;\r\n\r\n    &.active {\r\n      z-index: 1000;\r\n    }\r\n\r\n    .input-container input {\r\n      height: $tryitout-export-field-height !important;\r\n      border-radius: $tryitout-export-field-radius !important;\r\n      border: $tryitout-export-field-border !important;\r\n      background-color: #fff !important;\r\n      font-size: 12px !important;\r\n      padding-right: 12% !important;\r\n\r\n      &:disabled {\r\n        background-color: #f5f7fa !important;\r\n        cursor: not-allowed;\r\n        color: rgba(0, 0, 0, 0.6);\r\n      }\r\n    }\r\n\r\n    .suggestions-container {\r\n      position: absolute !important;\r\n      top: calc(100% + 2px) !important;\r\n      left: 0 !important;\r\n      right: 0 !important;\r\n      width: 100% !important;\r\n      overflow: hidden !important;\r\n      z-index: 1001 !important;\r\n      background: #fff !important;\r\n      border-radius: $tryitout-export-field-radius;\r\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important;\r\n      box-sizing: border-box;\r\n    }\r\n\r\n    .suggestions-container.is-visible {\r\n      z-index: 1001 !important;\r\n    }\r\n\r\n    .suggestions-container ul {\r\n      margin: 0;\r\n    }\r\n\r\n    .suggestions-container ul li a {\r\n      padding: 8px 12px !important;\r\n      font-size: $fontsize !important;\r\n      white-space: normal;\r\n      word-break: break-word;\r\n    }\r\n  }\r\n\r\n  .tryitout-export-control-vendor {\r\n    @include tryitout-export-suggestions-max-height(200px);\r\n  }\r\n\r\n  .tryitout-export-control-msgtype {\r\n    @include tryitout-export-suggestions-max-height(170px);\r\n  }\r\n\r\n  .tryitout-export-control-conversion {\r\n    @include tryitout-export-suggestions-max-height(80px);\r\n  }\r\n\r\n  .export-accession-input,\r\n  .export-direction-select {\r\n    width: 100%;\r\n    height: $tryitout-export-field-height !important;\r\n    border-radius: $tryitout-export-field-radius;\r\n    border: $tryitout-export-field-border;\r\n    box-shadow: $tryitout-export-input-shadow !important;\r\n    background-color: #fff;\r\n    font-size: 12px;\r\n    padding: 6px 12px;\r\n    color: rgba(0, 0, 0, 0.87);\r\n\r\n    &:focus {\r\n      border-color: #9e9e9e;\r\n      outline: none;\r\n      box-shadow: $tryitout-export-input-shadow !important;\r\n    }\r\n  }\r\n\r\n  .export-direction-select--readonly {\r\n    cursor: default;\r\n    background-color: #f5f7fa;\r\n  }\r\n\r\n  .export-direction-select--editable {\r\n    cursor: pointer;\r\n    padding-top: 0;\r\n    padding-bottom: 0;\r\n\r\n    ::ng-deep .mat-mdc-select-trigger,\r\n    ::ng-deep .mat-select-trigger {\r\n      height: $tryitout-export-field-height;\r\n      align-items: center;\r\n    }\r\n  }\r\n}\r\n\r\n// Direction dropdown panel only (field stays aligned; panel shifts left)\r\n::ng-deep .cdk-overlay-pane:has(.tryitout-export-direction-panel) {\r\n  transform: translateX(-10px);\r\n}\r\n\r\n::ng-deep .cdk-overlay-container .mat-mdc-select-panel.tryitout-export-direction-panel {\r\n  --mat-minimal-pseudo-checkbox-selected-checkmark-color: #157a9f;\r\n  --mat-full-pseudo-checkbox-selected-icon-color: #157a9f;\r\n\r\n  .mat-mdc-option.mdc-list-item--selected .mat-pseudo-checkbox-minimal.mat-pseudo-checkbox-checked::after,\r\n  .mat-mdc-option.mdc-list-item--selected .mat-pseudo-checkbox-full.mat-pseudo-checkbox-checked::after {\r\n    color: #157a9f !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .tryitout-export-fields-panel {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.Template_dropDown{\r\n  height: 32px;\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  position: relative;\r\n  top: 1%;\r\n  background-color: white;\r\n  margin-left: 1px;\r\n  margin-right: 2%;\r\n  margin-block: 1%;\r\n}\r\n::ng-deep.Template_dropDown  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.Template_dropDown .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n::ng-deep.Template_dropDown .mat-form-field-label-wrapper{\r\n  top:-1px !important;\r\n}\r\n::ng-deep.Template_dropDown  .mat-select-trigger {\r\n  min-width: 10vw;\r\n}\r\n.mat_selection{\r\n  // width: 62%;\r\n  margin-left: 4%;\r\n  margin-bottom: 4%;\r\n  height: 35px;\r\n  // box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  padding-bottom: 1%;\r\n}\r\n::ng-deep.mat_selection  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.mat_selection .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n::ng-deep.mat-selection_label .mat-form-field-label-wrapper{\r\n  position: absolute !important;\r\n  top: 1px !important;\r\n}\r\n::ng-deep.mat-selection_label  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.selection_label .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n\r\n::ng-deep.selection_label  .mat-select-trigger {\r\n  min-width: 10vw;\r\n}\r\n::ng-deep.path_class{\r\n    width: 100%;\r\n    // margin-top: 1%;\r\n}\r\n\r\n::ng-deep.pushmodal .modal-dialog {\r\n  max-width:50%!important;\r\n  max-height: 60%!important;\r\n  height: 60%!important;\r\n  margin: auto!important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.pushmodal{\r\n  top: 4%!important;\r\n}\r\n\r\n.ellipsisfull{\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  /* width: 100% !important; */\r\n  max-width: 90%;\r\n}\r\n\r\n::ng-deep .field_droping .mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label{\r\n  margin-left: 8px !important;\r\n}\r\n\r\n::ng-deep .field_droping .mat-form-field-appearance-outline .mat-form-field-infix{\r\n  padding: 3px 7px !important;\r\n}\r\n\r\n\r\n::ng-deep.Version_dropDowns .mat-form-field-wrapper .mat-form-field-flex .mat-form-field-infix .mat-select .mat-select-trigger .mat-select-value{\r\n  width: 65% !important;\r\n}\r\n.Version_dropDowns{\r\n  height: 32px;\r\n  border-radius: 5px;\r\n  position: relative;\r\n  top: -7px;\r\n  background-color: white;\r\n  margin-block: 1%;\r\n  padding-left: 5px;\r\n  width: 60%;\r\n}\r\n::ng-deep.Version_dropDowns  .mat-form-field-infix{\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 13px;\r\n}\r\n::ng-deep.Version_dropDowns .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n::ng-deep.Version_dropDowns .mat-form-field-label-wrapper{\r\n  top:-1px !important;\r\n}\r\n::ng-deep.Version_dropDowns  .mat-select-trigger {\r\n  min-width: 13vw !important;\r\n}\r\n::ng-deep.Version_dropDowns  .mat-select-arrow {\r\n  position: relative !important;\r\n  right: 47% !important;\r\n}\r\n\r\n\r\n::ng-deep.myCustomModalViewfilehl7Viewer .modal-dialog {\r\n  max-width: 80% !important;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  padding: 0 !important;\r\n  display: flex !important;justify-content: center !important;\r\n  .modal-content{\r\n  height: 70vh;\r\n  }\r\n}\r\n::ng-deep.myCustomModalViewfilehl7ViewerFromCreate .modal-dialog {\r\n  max-width: 80% !important;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  padding: 0 !important;\r\n  display: flex !important;justify-content: center !important;\r\n  .modal-content{\r\n  height: 70vh;\r\n  }\r\n}\r\n::ng-deep.matoutlinestyles.versionfield\r\n{\r\n  width: 70% !important;\r\n  .mat-mdc-text-field-wrapper{\r\n    padding-block: 0px !important;\r\n  }\r\n}\r\n::ng-deep.modal-backdrop.show {\r\nz-index: 1050 !important;\r\n}","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
